import { action } from 'easy-peasy';
import { IActionSetHospitalCounters } from '../types';

const setHospitalCounters: IActionSetHospitalCounters = action((state, payload) => {
  state.counters = payload;
});

export default setHospitalCounters;
